/**
 * 批量替换的动态组件
 *
 * 可配置参数：this.itemCopy.parameter.isDiff = {...}
 * @param {Object} [isDiff] 差异化渲染配置
 * @param {Boolean} isDiff.status 是否开启差异化组件渲染
 * @param {String} isDiff.scope 作用域 可选值：原始值 origin | 替换后 after 与此组件的 props.scope 相等可渲染
 * @param {String} isDiff.componentClassName 组件 code，eg. Input
 * @param {Object} isDiff.componentProps 组件 props
 *
 */
import dynamicItemUtil from '../dynamicFrom/libs/dynamicItemUtil'
import objectUtil from '../../static/js/objectUtil'

export default {
  name: 'batchItemDynamic',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    item: null,
    value: null,
    // 指定渲染的是原始的 or 替换后，可选值为：origin | after
    scope: null,
  },
  data() {
    return {
      itemCopy: null,
      data: this.value,
    }
  },
  watch: {
    // 注意 this.itemCopy 的赋值，避免出现重复渲染
    item(val) {
      if (val) {
        this.itemCopy = null
        setTimeout(() => {
          this.itemCopy = this.item
        })
      }
    },
    value(val) {
      this.data = val
    },
    data(val) {
      this.$emit('input', val)
    },
  },

  beforeDestroy() {
    this.data = null
  },

  methods: {},
  render(h) {
    let optionModel = {
      value: this.data,
      callback: (modelValue, isInitData) => {
        this.data = modelValue
      },
    }

    var vNodeFn = h('Input', {
      props: {
        clearable: true,
      },
      model: optionModel,
    })
    if (this.itemCopy) {
      let componentCode = objectUtil.getValueByPath(this.itemCopy, 'component.code')
      let componentClassName = dynamicItemUtil.convertComponentName(componentCode)
      if (!this.itemCopy.parameter) {
        this.itemCopy.parameter = {
          clearable: true,
        }
      } else {
        this.itemCopy.parameter.clearable = true
      }
      this.itemCopy.parameter.disabled = this.disabled

      /**
       * 需求：#16226
       *
       * 根据参数 this.itemCopy.parameter.isDiff 更新 componentClassName 的值
       * 差异化组件渲染的状态，开启：true | 关闭：false
       */
      console.log('this.itemCopy.parameter: ', this.itemCopy.parameter)
      const isDiff = this.itemCopy.parameter?.isDiff
      const status = isDiff?.status
      // 作用于原始值，还是替换后的值 eg. 原始值：origin | 替换后：after
      const scope = isDiff?.scope
      // 是否开启差异化组件渲染
      if (status && this.scope === scope) {
        const componentProps = isDiff?.componentProps
        componentClassName = isDiff?.componentClassName || 'Input'
        // 此方式赋值，避免引起 this.item 的改变，导致上面 watch 的重复（不必要的重复渲染）
        Object.keys(componentProps).forEach((key) => {
          this.itemCopy.parameter[key] = componentProps[key]
        })
      }

      vNodeFn = h(componentClassName, {
        props: this.itemCopy.parameter,
        model: optionModel,
        style: {
          width: '100%',
        },
      })

      // vNodeFn = h("div", {
      //     props: propsCompile,
      //     model: optionModel
      // });
    }

    return vNodeFn
  },
}
